import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import {
  type DynamicPricingQueryType,
  type DynamicPricingType,
  type DynamicPricingPaginationType,
  type DynamicPricingDetailType,
  type GetDynamicPricingResponseType,
} from 'features/DynamicPricing/service/dynamicPricing'

export interface DynamicPricingInitialStateInterface {
  isLoading: boolean
  query: DynamicPricingQueryType
  dynamicPricing: DynamicPricingType[]
  pagination: DynamicPricingPaginationType
  dynamicPricingDetail: DynamicPricingDetailType
  dialogState: {
    isOpen: boolean
    type: 'edit' | 'cancel' | ''
  }
}

const initialState: DynamicPricingInitialStateInterface = {
  isLoading: false,
  query: {} as DynamicPricingQueryType,
  dynamicPricing: [],
  dynamicPricingDetail: {} as DynamicPricingDetailType,
  pagination: {} as DynamicPricingPaginationType,
  dialogState: {
    isOpen: false,
    type: 'edit',
  },
}

export const sliceName = 'dynamicPricing'

const appSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    setLoading: (
      state,
      action: PayloadAction<DynamicPricingInitialStateInterface['isLoading']>,
    ) => {
      state.isLoading = action.payload
    },
    setQuery: (state, action: PayloadAction<DynamicPricingQueryType>) => {
      state.query = action.payload
    },
    setDynamicPricing: (state, action: PayloadAction<GetDynamicPricingResponseType>) => {
      state.dynamicPricing = action.payload.data
      state.pagination = action.payload.pagination
    },
    setDynamicPricingDetail: (state, action: PayloadAction<DynamicPricingDetailType>) => {
      state.dynamicPricingDetail = action.payload
    },
    setDialogState: (
      state,
      action: PayloadAction<DynamicPricingInitialStateInterface['dialogState']>,
    ) => {
      state.dialogState = action.payload
    },
  },
})

export const { setLoading, setQuery, setDynamicPricing, setDynamicPricingDetail, setDialogState } =
  appSlice.actions

export default appSlice.reducer
